import {ReduceStore} from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { TyreIndexExplanationLightboxActions } from '../constants/tyre_index_explanation_lightbox/tyre_index_explanation_lightbox_actions';

class TyreIndexExplanationLightboxStoreClass extends ReduceStore {
    getInitialState() {
        return false;
    }

    reduce(state, {source, action}) {
        const { type } = action;

        if (source === ACTION_TYPES.TYRE_INDEX_EXPLANATION_LIGHTBOX_ACTION) {
            switch (type) {
                case TyreIndexExplanationLightboxActions.OPEN:
                    if (!state) {
                        state = true;
                        this.__emitChange();
                    }
                    break;

                case TyreIndexExplanationLightboxActions.CLOSE:
                    if (state) {
                        state = false;
                        this.__emitChange();
                    }
                    break;
            }
        }

        return state;
    }
}

const TyreIndexExplanationLightboxStore = new TyreIndexExplanationLightboxStoreClass(Dispatcher);
export { TyreIndexExplanationLightboxStore };